import React from 'react';

import { dateService } from '../../../services/date';

import './styles/retailer-performance.scss';

const performanceMap = {
  publisher_total_earnings: 'Earnings',
  clicks: 'Clicks',
  publisher_epc: 'EPC',
};

const RetailerPerformance = ({ retailer, dateRange }) => {
  const performanceStats = Object.keys(performanceMap).map((key, idx) => {
    const performanceChange = retailer[`${key}_change`];

    function getPreviousLabel() {
      const daysInRange = Math.floor(
        dateService.subtractDates(dateRange.startDate, dateRange.endDate, 'day'),
      );
      return `Vs. Previous ${daysInRange} Days`;
    }

    return (
      <div key={idx} className={key}>
        <div className="all">
          <span className="label">{performanceMap[key]}</span>
          <div className="value-change">
            <div className="value">{retailer[key]}</div>
            <div className="performance-change">
              <span className={`${performanceChange >= 0 ? 'positive' : 'negative'}`}>
                {Math.abs(performanceChange)}%
              </span>
              <span>{getPreviousLabel()}</span>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return <div className="performance-container">{performanceStats}</div>;
};

export default RetailerPerformance;
